export function customComparator(valueA, valueB)  {
  if (!valueA && !valueB) {
    return 0;
  }
  if (!valueA) {
      return -1;
  }
  if (!valueB) {
      return 1;
}  return valueA.toLowerCase().localeCompare(valueB.toLowerCase());
};
